import { Box, Container } from "@mui/material";
import React from "react";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";
import JsonTextEditor from "./JsonTextEditor";
import { API_ENDPOINT } from "../../utils/constants";

const RawSendMessage = () => {
  return (
    <Container maxWidth="md">
      <BackBtn />
      <PageTitle>Send Raw Message</PageTitle>
      <Box mt={1}>
        <JsonTextEditor
          apiEndpoint={`${API_ENDPOINT}/api/send-raw-message`}
          onSuccess={(response) => {
            console.log("response", response);
          }}
        />
      </Box>
    </Container>
  );
};

export default RawSendMessage;
